var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUpDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10237_64983",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 12,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8334 27.4167C17.3732 27.4167 17.0001 27.0436 17.0001 26.5833L17.0001 17.3452L15.0893 19.2559C14.7639 19.5814 14.2363 19.5814 13.9108 19.2559C13.5854 18.9305 13.5854 18.4028 13.9108 18.0774L17.2442 14.7441C17.4006 14.5876 17.6129 14.4998 17.8341 14.5C18.0554 14.5002 18.2675 14.5883 18.4236 14.7451L21.757 18.0894C22.0819 18.4154 22.081 18.943 21.755 19.2679C21.4291 19.5928 20.9014 19.5919 20.5765 19.266L18.6667 17.3499L18.6667 26.5833C18.6667 27.0436 18.2937 27.4167 17.8334 27.4167Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.1667 29.5C25.9453 29.5 25.7329 29.4118 25.5765 29.2549L22.2432 25.9105C21.9183 25.5846 21.9192 25.0569 22.2451 24.732C22.5711 24.4071 23.0988 24.408 23.4236 24.734L25.3334 26.6501L25.3334 17.4167C25.3334 16.9564 25.7065 16.5833 26.1667 16.5833C26.627 16.5833 27.0001 16.9564 27.0001 17.4167V26.6501L28.9099 24.734C29.2347 24.408 29.7624 24.4071 30.0884 24.732C30.4143 25.0569 30.4152 25.5846 30.0903 25.9105L26.757 29.2549C26.6006 29.4118 26.3882 29.5 26.1667 29.5Z",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_10237_64983)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 12,
    width: 20,
    height: 20,
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpDown);
export default __webpack_public_path__ + "static/media/arrow-up-down.5269a95218d18d788a2f8b55f5ef8335.svg";
export { ForwardRef as ReactComponent };